import store from '@shared/store/index';

/**
 * Активирует фильтр Forecasters по выбранной монете
 * @param {Object} coin — объект монеты (обязательно с полем api_id)
 */
export async function callForecasterCoinFilter(coin) {
  if (!coin || !coin.api_id) {
    console.error('callForecasterCoinFilter: неверный объект монеты', coin);
    return;
  }
  try {
    await store.dispatch('Forecasters/addCoinToStore', coin);
  } catch (error) {
    console.error('Ошибка при вызове callForecasterCoinFilter:', error);
  }
}